<!-- Titolo, contenuto e fascia delle azioni sono figli DIRETTI della superficie
     (niente <div> di raggruppamento): e' la condizione perche' la veste
     .izy-guide-dialog-panel tenga la fascia panna a filo del bordo inferiore. -->
<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  <!-- Testo semplice dall'admin: solo interpolazione, a capo preservati. -->
  <p class="whats-new-body mt-3 pb-3">{{ data.body }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    matButton="filled"
    mat-dialog-close
    class="izy-button-primary custom-button-border">
    <mat-icon>check</mat-icon>
    Ho capito!
  </button>
</mat-dialog-actions>
